import React from 'react';

interface BranchProps {
  test: (() => boolean) | boolean;
  left: any;
  right: any;
}

export const Branch = ({ test, left, right, ...props }: BranchProps): any => {
  if (typeof test == 'function') {
    return test()
      ? React.cloneElement(left, props)
      : React.cloneElement(right, props);
  }

  return test
    ? React.cloneElement(left, props)
    : React.cloneElement(right, props);
};
